import { render, staticRenderFns } from "./ViewDetailsReportPostura.vue?vue&type=template&id=7cfbaea8&scoped=true"
import script from "./ViewDetailsReportPostura.vue?vue&type=script&lang=js"
export * from "./ViewDetailsReportPostura.vue?vue&type=script&lang=js"
import style0 from "./ViewDetailsReportPostura.vue?vue&type=style&index=0&id=7cfbaea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfbaea8",
  null
  
)

export default component.exports